<template><div><h1 id="technische-funktionen-zuordnen" tabindex="-1"><a class="header-anchor" href="#technische-funktionen-zuordnen"><span>Technische Funktionen zuordnen</span></a></h1>
<p>Technische Funktionen zuordnen — Technische Funktionen zu Benutzerfunktionen verknüpfen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die <RouteLink to="/referenz/refs/ft.refdata.techfunktionen.html" title="Technische Funktionen">Technischen Funktionen</RouteLink> (Programme) den <RouteLink to="/referenz/refs/ft.refdata.benutzerfunktionen.html" title="Benutzerfunktionen">Benutzerfunktionen</RouteLink> zugeordnet. Die Einträge werden von Arenae Consulting AG verwaltet.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Benutzerverwaltung → Benutzerfunktionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Programmname</dt>
<dd>Programm</dd>
<dt>Variablen</dt>
<dd>Programm-Variablen</dd>
<dt>Funktionsbezeichnung</dt>
<dd>Beschreibung der Funktion</dd>
<dt>Benutzerfunktion</dt>
<dd>Zugeordnete <a class="link" href="ft.refdata.benutzer.html" title="Benutzerstamm">Benutzerfunktion</a></dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>keine</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/benutzerverwaltung.html#Benutzerverwaltung" title="1. Benutzerverwaltung">Benutzerverwaltung</RouteLink></p>
</div></template>


